// extracted by mini-css-extract-plugin
export default {"tagsContainer":"Tags_tagsContainer__9eqpV"};